<section class="order-general-information">
  <!-- Order Information -->
  <p-panel header="Order Information" styleClass="mb-3 panel-simple border">
    <div class="p-3">
      <app-loader></app-loader>
      <!-- contact info section -->
      <section class="border-bottom-dotted">
        <label class="semi-bold-text mb-2 font-15">Contact Information</label>
        @if(orderDetails?.contacts?.length){
        @for(contact of orderDetails?.contacts; let indx = $index; track contact){
        <div class="mb-3">
          <label class="semi-bold-text heading-color mb-2 font-15"> Contact {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }}
              </label>
              <div class="row mb-0 mb-lg-3">
                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label class="medium-text d-block">Contact Name</label>
                  <label>{{ contact.displayName }}</label>
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label class="medium-text d-block">Phone</label>
                  <label>{{ contact.phone }}</label>
                  <label *ngIf="contact.extension && contact.extension !== '--'">&nbsp; extn.&nbsp;{{contact.extension}}</label>
                </div>
                <!-- <div class="col mb-3 mb-sm-0" *ngIf="contact.extension && contact.extension !== '--'">
                  <label class="medium-text d-block">Extn</label>
                  <label>{{ contact.extension }}</label>
                </div> -->
                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label class="medium-text d-block">Email</label>
                  <label>{{ contact.email }}</label>
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                  <label class="medium-text d-block">Title</label>
                  <label>{{ contact.title }}</label>
                </div>
              </div>
              @if(contact.barNumber){
              <div class="row mb-0 mb-lg-3">
                <div class="col-sm-12 mb-3 mb-sm-0">
                  <label class="medium-text d-block">Bar Number</label>
                  <label>{{ contact.barNumber }}</label>
                </div>
              </div>
              }
        </div>
        }
      }
      </section>

      <!-- billing info section -->
      <section class="border-bottom-dotted mt-3">
        <label class="semi-bold-text mb-2 font-15">Billing Information</label>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block">Email</label>
            <label>{{ orderDetails?.billingInfo?.email }}</label>
          </div>
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block">Billing Contact Name</label>
            <label>{{ orderDetails?.billingInfo?.billingContactName }}</label>
          </div>
        </div>
      </section>

      <!-- delivery info section -->
      <section class="border-bottom-dotted mt-3">
        <label class="semi-bold-text mb-2 font-15">Delivery Information</label>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block">Attention To</label>
            <label>{{ orderDetails?.deliveryInfo?.attentionTo }}</label>
          </div>
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block">Firm Name</label>
            <label>{{ orderDetails?.deliveryInfo?.firmTo }}</label>
          </div>
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block">Phone</label>
            <label>{{ orderDetails?.deliveryInfo?.phone || '--'}}</label>
            <label *ngIf="orderDetails?.deliveryInfo?.extension && orderDetails?.deliveryInfo?.extension !== '--'">&nbsp;extn.&nbsp;{{orderDetails?.deliveryInfo?.extension}}</label>
          </div>
          <!-- <div class="col mb-3 mb-sm-0" *ngIf="orderDetails?.deliveryInfo?.extension">
            <label class="medium-text d-block">Extn</label>
            <label>{{ orderDetails?.deliveryInfo?.extension}}</label>
          </div> -->
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block">Address</label>
            <div class="d-flex flex-column">
              <label>{{ orderDetails?.deliveryInfo?.address }}</label> <!-- address line one -->
              <!--<label>{{ orderDetails?.deliveryInfo?.address }}</label>--> <!-- address line two -->
            </div>
          </div>
        </div>
      </section>

      <!-- attachments section -->
      <section class="border-bottom-dotted mt-3">
        <label class="semi-bold-text mb-2 font-15">Attachments</label>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-3 mb-3 mb-sm-0">
            <label class="medium-text d-block mb-1">Label</label>
            <div class="d-grid gap-0 row-gap-2">
              <label *ngFor="let attachment of orderDetails?.attachmentInfo">{{ attachment.description }}</label>
            </div>
          </div>
          <div class="col-sm-5 mb-3 mb-sm-0">
            <label class="medium-text d-block mb-1">Uploaded Files</label>
            <div class="d-grid gap-0 row-gap-2">
              <p-button aria-label="Downloadable File" styleClass="p-0" label="{{ attachment.fileName }}" *ngFor="let attachment of orderDetails?.attachmentInfo" (onClick)="downloadFile(attachment)" [link]="true" />
              <!-- <a href="#" *ngFor="let attachment of orderDetails?.attachmentInfo" (onclick)="downloadFile(attachment)">{{ attachment.fileName }}</a> -->
            </div>
          </div>
        </div>
      </section>

      <!-- Special Instructions -->
      @if(orderDetails?.specialInstructions){
      <section class="mt-3">
        <label class="medium-text mb-2 font-15">Special Instructions</label>
        <p class="m-0">
          {{ orderDetails?.specialInstructions }}
        </p>
      </section>
      }
    </div>
  </p-panel>

  <!-- Record Subjects -->
  <p-panel header="Record Subjects" styleClass="mb-3 panel-simple border">
    <!-- <div > -->
    <section class="p-3">
      @for(subject of orderDetails?.subjects; let indx = $index; track subject){
        <!-- <div> -->
      <label class="semi-bold-text heading-color mb-2 font-15">Subject {{ indx < 9 ? "0" + (indx + 1) : indx + 1
          }}</label>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Record Subject Name</label>
              <label>{{ subject.name }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Alias</label>
              <label>{{ subject.alias || "--" }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Date of Birth</label>
              <label>{{ subject.dateOfBirth | date: 'MM/dd/yyyy' }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Last 4 digits of SSN</label>
              <label>{{ subject.lastDigitOfSSN || "--"}}</label>
            </div>
          </div>
          @if(subject.dateOfDeath){
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text d-block">Date of Death (If Applicable)</label>
              <label>{{ subject.dateOfDeath | date: 'MM/dd/yyyy' }}</label>
            </div>
          </div>
          }
          <!-- </div> -->
          }
    </section>
    <!-- </div> -->
  </p-panel>

  <!-- add this code in new component -->

  <ng-template #panelTemplate let-counsels>
    <section>
      @for(counsel of counsels; let indx = $index; track counsel) {
      <!-- <div> -->
      <label class="semi-bold-text mb-2 heading-color font-15"> Opposing Counsel {{ indx < 9 ? "0" + (indx + 1) : indx +
          1 }} </label>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Record Subject Name</label>
              <label>{{ counsel.recordSubjectName }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Opposing Counsel Attorney Name</label>
              <label>{{ counsel.attorneyName }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Opposing Counsel Firm Name</label>
              <label>{{ counsel.firmName }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Address</label>
              <div class="d-flex flex-column">
                <label>{{ counsel.address || "--" }}</label> <!-- address line one -->
                <!--<label>{{ counsel.address || "--" }}</label>--> <!-- address line two -->
              </div>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Phone</label>
              <label>{{ counsel.phone || "--" }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Fax</label>
              <label>{{ counsel.fax || "--" }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Email</label>
              <label>{{ counsel.email || "--" }}</label>
            </div>
          </div>
          <!-- </div> -->
          }
    </section>
  </ng-template>

  <!-- Authorization to be Obtained by EXL Panel -->
  @if(orderDetails?.counselInfo?.length){
  <p-panel header="Authorization to be Obtained by EXL" styleClass="mb-3 panel-simple border"
    *ngIf="orderDetails?.typeOfOrder === 'Authorization not provided - EXL to obtain'">
    <div class="p-3">
      <ng-container *ngTemplateOutlet="
          panelTemplate;
          context: { $implicit: orderDetails?.counselInfo }
        "></ng-container>
    </div>
  </p-panel>
  }

  <!-- Subpoena to be Prepared by EXL panel -->
  <p-panel header="Subpoena to be Prepared by EXL" styleClass="mb-3 panel-simple border"
    *ngIf="orderDetails?.typeOfOrder === 'Subpoena to be prepared by EXL'">
    <!-- <div class="p-3"> -->
    <!-- counsel content -->
    <section class="p-3">
      <ng-container *ngTemplateOutlet="
          panelTemplate;
          context: { $implicit: orderDetails?.subpoena?.counselInfo }
        "></ng-container>
      <!-- defendant content -->
      @for(defendant of orderDetails?.subpoena?.defendant; let indx = $index; track defendant){
      <!-- <div> -->
      <label class="semi-bold-text mb-2 heading-color font-15">
        Defendant {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }} </label>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Defendant Name</label>
              <label>{{ defendant.name }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Address</label>
              <div class="d-flex flex-column">
                <label>{{ defendant.address }}</label> <!-- address line one -->
                <!--<label>{{ defendant.address }}</label>--> <!-- address line two -->
              </div>
            </div>
          </div>
          }

          <!-- Court Details subsection  -->
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Judge</label>
              <label>{{ orderDetails?.subpoena?.judge || "--"}}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Court</label>
              <label>{{ orderDetails?.subpoena?.court }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Court Address</label>
              <div class="d-flex flex-column">
                <label>{{ orderDetails?.subpoena?.courtAddress || "--"}}</label> <!-- address line one -->
                <!--<label>{{ orderDetails?.subpoena?.courtAddress || "--"}}</label>--> <!-- address line two -->
              </div>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Jurisdiction County</label>
              <label>{{ orderDetails?.subpoena?.jurisdictionCounty }}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">State</label>
              <label>{{ orderDetails?.subpoena?.state || "--" }}</label>
            </div>
          </div>
          <!-- </div> -->
    </section>
    <!-- </div>   -->
  </p-panel>

  <!-- Records section -->

  <p-panel header="Records" styleClass="mb-3 panel-simple border">
    <!-- <div class="p-3"> -->
    <section class="p-3">
      <ng-container *ngFor="let item of orderDetails?.providers | keyvalue: keepOriginalSorting; let indx = index; trackBy: trackByKey">
        <ng-container *ngIf="item.value as provider">
      <!-- @for(item of orderDetails?.providers | keyvalue; let indx = $index; track item.key) {
        @let provider = item.value;  -->
      <!-- <div> -->
      <label class="semi-bold-text mb-2 font-15 heading-color">
        Provider {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }} </label>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Provider (Institution)</label>
              <label>{{ provider.provider }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Doctor</label>
              <label>{{ provider.doctor || "--" }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Address</label>
              <div class="d-flex flex-column">
                <label>{{ provider.address }}</label> <!-- address line one -->
                <!--<label>{{ provider.address }}</label>--> <!-- address line two -->
              </div>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Email</label>
              <label>{{ provider.email }}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Record Subject</label>
              <label>{{ provider.recordSubject }}</label>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
              <label class="medium-text d-block">Record Range</label>
              <label>{{ provider.recordRange }}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text d-block">Record Type Requested</label>
              <label>{{provider.recordType}}</label>
            </div>
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text" *ngIf="provider.imaging.type || provider.ambulance.date ||
                provider.employment.ss || provider.insurance.claimNumber || provider.irs.ss || 
                provider.military.branch || provider.socialSecurity.ss || provider.union.membershipNumber ||
                provider.va.va || provider.other.descriptionOfRecords">
                Additional Details:
              </label>
              <ul>
                <li class="mb-2" *ngIf="provider.imaging.type">
                  <label class="text-underline semi-bold-text heading-color">Type of Imaging: </label>
                  <div>
                    <span>{{provider.imaging.type}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.imaging.type === 'Other'">
                    <label class="medium-text">Others: </label>
                    <span>{{provider.imaging.others}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.imaging.specificBodyPart">
                    <label class="medium-text">Specific Body Part/Area: </label>
                    <span class="overflow-wrap">{{provider.imaging.specificBodyPart}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.ambulance.date">
                  <label class="text-underline semi-bold-text heading-color">Ambulance: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Date of Ambulance Service: </label>
                    <span>{{provider.ambulance.date | date: 'MM/dd/yyyy'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Time of Ambulance Service: </label>
                    <span class="overflow-wrap">{{provider.ambulance.time || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Pick-up Address: </label>
                    <span class="overflow-wrap">{{provider.ambulance.pickupAddress || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Drop Address: </label>
                    <span class="overflow-wrap">{{provider.ambulance.dropAddress || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.employment.ss">
                  <label class="text-underline semi-bold-text heading-color">Employment: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">SS#: </label>
                    <span>{{provider.employment.ss}} </span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.insurance.claimNumber">
                  <label class="text-underline semi-bold-text heading-color">Insurance: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Claim Number: </label>
                    <span>{{provider.insurance.claimNumber}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Policy Number: </label>
                    <span class="overflow-wrap">{{provider.insurance.policyNumber || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.irs.ss">
                  <label class="text-underline semi-bold-text heading-color">IRS: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">SS#: </label>
                    <span>{{provider.irs.ss}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.military.branch">
                  <label class="text-underline semi-bold-text heading-color">Military: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Branch (if known) : </label>
                    <span>{{provider.military.branch || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Service Number (if known) : </label>
                    <span class="overflow-wrap">{{provider.military.serviceNumber || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.socialSecurity.ss">
                  <label class="text-underline semi-bold-text heading-color"> Social Security: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">SS# : </label>
                    <span>{{provider.socialSecurity.ss}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Record Subject Address: </label>
                    <span class="overflow-wrap">{{provider.socialSecurity.address}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.union.membershipNumber">
                  <label class="text-underline semi-bold-text heading-color"> Union: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Membership Number (if known) : </label>
                    <span>{{provider.union.membershipNumber || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.va.va">
                  <label class="text-underline semi-bold-text heading-color"> VA: </label>
                  <div>
                    <label>{{provider.va.va || '--'}} </label>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.other.descriptionOfRecords">
                  <label class="text-underline semi-bold-text heading-color"> Other: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Description of records : </label>
                    <span>{{provider.other.descriptionOfRecords}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3" *ngIf="provider.subpoenaLanguage">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text">Subpoena Language</label>
              <p class="m-0">
                {{ provider.subpoenaLanguage }}
              </p>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3" *ngIf="provider.notes">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text">Notes</label>
              <p class="m-0">
                {{ provider.notes }}
              </p>
            </div>
          </div>
          <!-- } -->
          </ng-container>
        </ng-container>
    </section>
    <!-- </div> -->
  </p-panel>
</section>